var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 149.998,
    viewBox: "0 0 150 149.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41418",
    "data-name": "Group 41418",
    transform: "translate(-152.946 -210.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19867",
    "data-name": "Path 19867",
    d: "M302.946,286.09a75,75,0,1,1-74.632-75.143A74.992,74.992,0,0,1,302.946,286.09Zm-138.269-.263a63.268,63.268,0,1,0,63.457-63.151A63.278,63.278,0,0,0,164.677,285.827Z",
    transform: "translate(0 0)",
    fill: "#674188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19868",
    "data-name": "Path 19868",
    d: "M195.148,263.233c0,6.04.023,12.078-.007,18.118-.018,4.01-2.3,6.641-5.738,6.716-3.544.077-5.97-2.623-5.976-6.771q-.031-17.971,0-35.943c.007-3.984,2.33-6.662,5.736-6.743,3.5-.082,5.958,2.68,5.976,6.8C195.169,251.348,195.148,257.29,195.148,263.233Z",
    transform: "translate(38.661 35.103)",
    fill: "#674188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19869",
    "data-name": "Path 19869",
    d: "M190.647,228.5a7.9,7.9,0,1,1-8.118,7.79A7.848,7.848,0,0,1,190.647,228.5Z",
    transform: "translate(37.54 22.272)",
    fill: "#674188"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.878c9d8bd2e0fa31786e851d82f1af3a.svg";
export { ForwardRef as ReactComponent };